import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertToDate } from '../../../components/utils';




export default function TableBoards({ description, items }) {
  const renderTableTitle = () => description
    ? <h3 className='table__title'>{description} Boards</h3>
    : null;

  const renderTableHead = () => (
    <div className='table__row table__row--header'>
      <div className='table__col'>Board</div>
      <div className='table__col'>Threads</div>
      <div className='table__col'>Messages</div>
      <div className='table__col'>Last Post</div>
    </div>
  )

  const renderTableBody = () => items.map(({ title, path, threads, messages, lastPost }) => (
    <div className='table__row' key={path}>
      <div className='table__col'>
        <Link to={path}>
          <FontAwesomeIcon icon={faComments} />
          { title }
        </Link>
      </div>
      <div className='table__col'>{threads}</div>
      <div className='table__col'>{messages}</div>
      <div className='table__col'>{convertToDate(lastPost)}</div>
    </div>
  ))

  return (
    <div className='table table--boards'>
      <div className='table__body'>
        { renderTableTitle() }
        { renderTableHead() }
        { renderTableBody() }
      </div>
    </div>
  )
}



TableBoards.defaultProps = {
  description: '',
  items: []
}

TableBoards.propTypes = {
  description: PropTypes.string, // description property is title
  items: PropTypes.arrayOf(PropTypes.object)
}